import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    latestVolunteers: []
};

const actions = {
    async fetchLatestVolunteers({ commit }) {
        await db.collection('/volunteers').get().then(
            (snapshot) => {
                var latestVolunteers = [];
                snapshot.forEach(doc => {
                    latestVolunteers.push(doc.data());
                });
                commit("updateField", {
                    path: "latestVolunteers",
                    value: latestVolunteers,
                })
            });
    },
    async fetchLatestVolunteers2({ commit }) {
        await db.collection('/pandemic2volunteers').get().then(
            (snapshot) => {
                var latestVolunteers = [];
                snapshot.forEach(doc => {
                    latestVolunteers.push(doc.data());
                });
                commit("updateField", {
                    path: "latestVolunteers",
                    value: latestVolunteers,
                })
            });
    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
